import { observable, action, decorate } from "mobx";

class UIStore {
  title = '';

  setTitle(title){
    this.title = title;
  }

}
decorate(UIStore, {
  title: observable,
  setTitle: action,

});

export default UIStore;
